// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c6a14f68","239":"5645d31e","453":"739ca32d","553":"a463f15e"}[chunkId] + ".chunk.js";
};